import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  earningReports: [],
  total_pages: 1,
  totalEarning: 0,
  searchEarningReports: [],
  searchEarningReportsValue: "",
};

const earningReports = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_EARNING_REPORTS:
      return {
        ...state,
        earningReports: [...action.payload.results],
        total_pages: action.payload.total_pages,
        totalEarning: action.payload.totalEarning,
      };
    case actionTypes.SEARCH_EARNING_REPORTS:
      return {
        ...state,
        searchEarningReports: action.search,
        searchEarningReportsValue: action.searchValue,
        total_pages: action.total_pages,
      };
    case actionTypes.EMPTY_EARNING_REPORTS:
      return {
        ...state,
        searchEarningReportsValue: "",
        searchEarningReports: [],
        earningReports: [],
        total_pages: 1,
      };
    default:
      return state;
  }
};

export default earningReports;
